import type { SVGProps } from 'react';
const SvgDecrease = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M14.779 9.281V12H12.06m1.94-.548-3.126-3.367a1.37 1.37 0 0 0-.644-.393c-.244-.067-.5-.06-.741.017L5.952 8.727a1.3 1.3 0 0 1-.72 0 1.4 1.4 0 0 1-.624-.388L1 4.452"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgDecrease;
